// @ts-nocheck
import { setCookie } from "@insite/client-framework/Common/Cookies";
import { updateContext } from "@insite/client-framework/Context";
import { addToChainBefore, ApiHandler } from "@insite/client-framework/HandlerCreator";
import { getAccount } from "@insite/client-framework/Services/AccountService";
import { Session, updateSession } from "@insite/client-framework/Services/SessionService";
import { getLanguages, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchCompleteSignIn,
    SignInParameter,
    SignInResult,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { LanguageModel } from "@insite/client-framework/Types/ApiModels";
import { userPreferredLanguageCustomPropertyName } from "@store/Extensions/Framework/Common/Utilities/getBrowserPreferredLanguageCode";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

export const ApplyAccountPreferredLanguageIfNeeded: HandlerType = async props => {
    const { authenticatedSession } = props;
    if (!authenticatedSession?.userProfileId) {
        return;
    }

    const account = await getAccount({ accountId: "" });
    const preferredLanguageCode = account.properties?.[userPreferredLanguageCustomPropertyName];
    if (!preferredLanguageCode || authenticatedSession.language?.languageCode === preferredLanguageCode) {
        return;
    }

    const matchingLanguage = getLanguages(props.getState())?.find(o => o.languageCode === preferredLanguageCode);
    if (!matchingLanguage) {
        return;
    }

    await updateSession({ session: { language: { id: matchingLanguage.id } as LanguageModel } as Session });
    updateContext({ languageId: matchingLanguage.id });

    const settings = getSettingsCollection(props.getState());
    const expires = settings?.accountSettings.daysToRetainUser || 365;
    setCookie("CurrentLanguageId", matchingLanguage.id, { path: "/", expires });

    const urlBeforeRemainingSignInSteps = window.location.href;
    setTimeout(() => {
        if (window.location.href === urlBeforeRemainingSignInSteps) {
            window.location.reload();
        }
    }, 200);
};

addToChainBefore(chain, DispatchCompleteSignIn, ApplyAccountPreferredLanguageIfNeeded);
